export default class WalletTemplatesDetailsController {
    constructor($scope, $injector) {
        this.scope = $scope;
        this.injector = $injector;
        this.api = this.injector.get('$http');
        this.alert = this.injector.get('Alert');
        this.state = this.injector.get('$state');
        this.stateParams = this.injector.get('$stateParams');
        this.navService = this.injector.get('NavService');
        this.workflowsService = this.injector.get('Workflows');

        this.template = null;
        this.loading = true;

        this.editorCancelTrigger = null;
    }

    $onInit() {
        this._loadTemplate();

        this.routeOutCheckDestruct = this.injector.get('$transitions').onBefore(
            {},
            trans => {
                return new Promise((resolve, reject) => {
                    if (!_.isFunction(this.editorCancelTrigger)) {
                        resolve(trans);
                        return;
                    }

                    this.editorCancelTrigger()
                        .then(() => {
                            resolve(trans);
                        })
                        .catch(() => {
                            resolve(false);
                        })
                });
            });

        this.scope.$on('$destroy', () => {
            if (_.isFunction(this.routeOutCheckDestruct)) {
                this.routeOutCheckDestruct();
            }
        });
    }

    handleCancel() {
        return this.state.go('app.wallets.templates.index');
    }

    handleSaveSuccess() {
        this._loadTemplate();
    }

    _loadTemplate() {
        return this.api.get(`wallets/templates/${this.stateParams.id}`)
            .then(({data}) => {
                this.template = data.data;
                this._decorateNavService();
                this.loading = false;
            })
            .catch((e) => {
                this.alert.handle(e);
                this.state.go('app.wallets.templates.index');
            })
    }

    _decorateNavService() {
        this.navService.setBreadcrumbParameters({
            template_name: this.template.name
        });

        const actions = _(this.workflowsService.getWorkflows('passbooks::details'))
            .filter(workflow => {
                return !!this.template.deleted_at ? workflow.level === 'archived-highlight' : workflow.level === 'highlight';
            })
            .map(workflow => {
                if (!workflow.onClick) {
                    workflow.onClick = workflow.action;
                }
                workflow.action = () => {
                    workflow.onClick(this.template, this);
                };
                workflow.order = workflow.order || 30;
                return workflow;
            })
            .sortBy('order', 'asc')
            .value();

        this.navService.overrideMainSideNavActions(actions);
    }
}

WalletTemplatesDetailsController.$inject = [
    '$scope',
    '$injector'
];



// WEBPACK FOOTER //
// ./src/app/modules/wallets/templates/controllers/pages/details.js